import { TableCell } from "@mui/material";
import { GridColDef, RowType } from "./AppTable";

type AppTableCellProps<T> = Omit<GridColDef<T>, "headerName"> & {
  row: T;
};

function AppTableCell<T extends RowType>(props: AppTableCellProps<T>) {
  const { field, render, align, row } = props;

  const cellContent = render ? render(row) : row[field as keyof typeof row]?.toString();

  return (
    <TableCell key={`${row.uid}-${field}`} scope="row" align={align}>
      {cellContent}
    </TableCell>
  );
}

export default AppTableCell;
